module.exports = __webpack_public_path__ + "static/media/trigo.86f213cb.png";